'use client';

import React from 'react';
import LeftBottomImg from '../../../public/images/left_bottom.png';
import RightBottomImg from '../../../public/images/right_bottom.png';
import { ToastContainer } from '@altus-ui/components_v2/ui/Toast';
import Header from '../components/Header';
import Footer from '../components/Footer';
import InterestContent from './interestContent';
import { ConsentContextProvider } from '../consent/consentContext';

export default function InterestForm() {
  const styling = {
    backgroundImage: `url('${LeftBottomImg.src}'), url('${RightBottomImg.src}')`,
    backgroundRepeat: 'no-repeat, no-repeat',
    backgroundPosition: 'left bottom, right bottom',
    backgroundSize: '215px 176px, 485px 330px'
  };

  return (
    <>
      <div
        className="z-20 flex-col min-w-[1280px] w-full h-fit min-h-full bg-white start-0 flex flxe-col justify-between relative"
        style={styling}>
        <Header />
        <div className="w-full flex min-h-[calc(100%-84px)] relative pt-[120px] pb-[52px] flex-1 flex-col items-center h-full overflow-hidden">
          <ConsentContextProvider>
            <InterestContent />
          </ConsentContextProvider>
        </div>
        <ToastContainer />
      </div>
      <Footer />
    </>
  );
}
